<template>
  <ion-page>
    <ion-content>
      <div class="wrap">
        <div class="login-form">
          <div class="form-header">
            <img src="../assets/model_space_logo.png" alt="Model Space" />
            <p>Login to access Model Space</p>
          </div>

          <div class="form-group">
            <ion-item>
              <ion-label position="stacked">Email</ion-label>
              <ion-input
                @ionChange="(_event) => (email = _event.detail.value)"
                :value="email"
                type="email"
                placeholder="email@account.com"
                clearInput
                clear-input="true"
                required="true"
              ></ion-input>
            </ion-item>
          </div>

          <div class="form-group">
            <ion-item>
              <ion-label position="stacked">Password</ion-label>
              <ion-input
                :value="password"
                @ionChange="(_event) => (password = _event.detail.value)"
                type="password"
                placeholder="********"
                clearInput
                clear-input="true"
                required="true"
              ></ion-input>
            </ion-item>
          </div>
          <!-- Password Input-->

          <div class="form-group">
            <ion-button @click="login" expand="full">Login</ion-button>
          </div>
          <!-- Login Button-->

          <error-message v-if="error" v-bind:message="error"></error-message>
        </div>
        <!-- /.login-form -->

        <div style="padding-top: 20px;">
          Version: 1.0.12
        </div>
      </div>

      <!-- /.wrap -->
    </ion-content>
  </ion-page>
</template>

<script>
import firebase from "firebase";
import pushTokenApiService from "../services/PushTokenApi";
import intercomApiService from "../services/IntercomApi";
import { Plugins } from "@capacitor/core";

const { Storage } = Plugins;

import { Deploy } from "cordova-plugin-ionic";

export default {
  name: "Login",
  data: function() {
    return {
      email: "",
      password: "",
      error: false,
    };
  },
  computed: {
    webOnly() {
      return process.env.VUE_APP_WEB_ONLY == "true";
    },
  },
  async mounted() {
    //check for updates
    const update = await Deploy.checkForUpdate();

    if (update.available) {
      return this.$router.push("updating");
    }
  },
  methods: {
    async login(e) {
      // Check that email or password are not empty
      if (this.email == "" || this.password == "") {
        this.error = "Email and Password must be filled in.";
        return;
      }

      // Begin loading
      const loading = await this.$ionic.loadingController.create({
        message: "Logging in...",
      });
      loading.present();

      try {
        // Sign in.
        const credential = await this.signIn(this.email, this.password);
        const user = credential.user;

        // Get bs_model_id from firestore collection.
        const bsModelRef = firebase
          .firestore()
          .collection("bsModels")
          .doc(user.uid);

        const bsModelDoc = await bsModelRef.get();
        const bsModelId = bsModelDoc.get("bs_model_id");

        // Reset values.
        this.email = "";
        this.password = "";
        this.error = "";

        //setups intercom - this is only avialable in native app
        if (!this.webOnly) {
          // Add device token to logged in user.
          try {
            var response = await pushTokenApiService.addDeviceTokenToUser(
              user.uid
            );
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
          }

          const token = response ? response.data.data.token : null;

          // Save token in local storage.
          if (token) {
            await Storage.set({
              key: "pushTokenSet",
              value: token,
            });
          }

          // Register user with Intercom.
          const registrationOptions = {
            userId: bsModelId.toString(),
            email: user.email,
          };

          await intercomApiService.registerUser(registrationOptions);

          if (token) {
            intercomApiService.registerPushAndroid(token);
            await intercomApiService.registerPushIos();
          }
        }

        // Show successful login message.
        this.showToast("You have successfully logged in.");

        // Redirect to page.
        this.$router.go({ path: this.$router.path });
      } catch (error) {
        // Set error message

        if (error.code == "auth/user-not-found") {
          error.message = "Email and password did not match!";
        }

        this.error = error;

        //push notification stuff
        if (!this.webOnly) {
          // Remove push token in local storage
          await Storage.remove({ key: "pushTokenSet" });
          // Sign Out
          intercomApiService.logout();
        }
        firebase.auth().signOut();
      } finally {
        // End loading
        loading.dismiss();
      }

      e.preventDefault();
    },

    async signIn(email, password) {
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .signInWithEmailAndPassword(email, password)
          .then((userCredentials) => resolve(userCredentials))
          .catch((reason) => reject(reason));
      });
    },

    async showToast(message) {
      const toast = await this.$ionic.toastController.create({
        message: message,
        showCloseButton: true,
        position: "bottom",
        closeButtonText: "Done",
        duration: 2000,
      });
      return await toast.present();
    },
  },
};
</script>

<style scoped>
.wrap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--ion-color-primary);
  flex-direction: column;
}

.bg-primary {
  background: var(--ion-color-primary);
}

.login-form {
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  border: 1px solid #ddd;
  padding: 2rem;
  background: #ffffff;
}

.form-input {
  background: #fafafa;
  border: 1px solid #eeeeee;
  padding: 12px;
  width: 100%;
}

.form-group {
  margin-bottom: 1rem;
}

.form-header {
  text-align: center;
  margin-bottom: 2rem;
}

.form-footer {
  padding-top: 16px;
  text-align: center;
}
</style>
